import React, { useContext, useState } from 'react'
import { DataContext } from '../../Context/Context'
import ReactStars from "react-rating-stars-component"
import { Link } from 'react-router-dom'
import formatCurrency from '../../Util/Util';
import "./ProductCard.css"
// icons
import prodcompare from '../../../assets/images/icon/prodcompare.svg'
import view from '../../../assets/images/icon/view.svg'
import addCartsvg from '../../../assets/images/icon/add-cart.svg'




const ProductCard = ({ product }) => {
  const value = useContext(DataContext);
  const [products, setProducts] = value.products;
  const addCart = value.addCart;
  const addWish = value.addWish;
  const addCompare = value.addCompare;

  return (
    <>
      {/* {
        products.map(product => ( */}
      {/* <div className='col-12 col-sm-6 col-lg-3  p-2'> */}
      <div className="product-card position-relative border text-center">
        <div className="wishlist-icon position-absolute">
          <Link onClick={() => addWish(product._id)}>
            <i className="bi bi-heart h6 empt"></i>
            <i className="bi bi-heart-fill h6 fillh d-none"></i>
          </Link>
        </div>
        <Link to={`/products/${product._id}`}>
          <div className="product-image px-4 ">
            <img src={product.images[0]} className='img-fluid rounded img1' alt="product-img" />
            <img src={product.images[1]} className='img-fluid rounded img2' alt="product-img" />
          </div>
        </Link>
        <div className="product-details pt-4">
          <h6 className='brand'>  {product.name}   </h6>
          <h5 className="product-title lh-base">
            {product.fullName}
          </h5>
          <div className="d-flex justify-content-center">
            <ReactStars
              count={5}
              size={24}
              value={3}
              activeColor="#ffd700"
            />
          </div>
          <div className="d-flex justify-content-end pt-3">
            <p className="price h6 text-danger fw-bold"> {formatCurrency(product.price)}  </p>
          </div>
        </div>

        <div className="action-bar position-absolute">
          <div className="d-flex flex-column gap-10">
            <Link onClick={() => addCompare(product._id)}>
              <img src={prodcompare} alt="compare" />
            </Link>
            <Link to='/store'>
              <img src={view} alt="view" />
            </Link>
            <Link onClick={() => addCart(product._id)}>
              <img src={addCartsvg} alt="addcard" />
            </Link>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* ))
      } */}
    </>
  )
}

export default ProductCard